import { render, staticRenderFns } from "./select-book.vue?vue&type=template&id=09fce318&scoped=true"
import script from "./select-book.vue?vue&type=script&lang=js"
export * from "./select-book.vue?vue&type=script&lang=js"
import style0 from "./select-book.vue?vue&type=style&index=0&id=09fce318&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fce318",
  null
  
)

export default component.exports